export default {
  titles: {
    listOld: 'Old invoices list',
    oldLimit: '* Only invoices with a signature date older than 5 years old will be shown.',
    list: 'Invoice list',
    payList: 'Invoice list to pay',
    financing: 'Invoice list to Financing',
    asProviderList: {
      enviadas: 'List of invoices sent',
      aceptadas: 'List of invoices accepted',
      rechazadas: 'List of invoices rejected'
    },
    asPayerList: {
      pendientes: 'List of invoices pending treatment',
      tratadas: 'List of invoices treated'
    }
  },
  searcher: 'Search',
  rectified: {
    find: {
      seeRectified: 'Watch rectified',
      seeRectifying: 'Watch rectifying'
    },
    errors: {
      rectifyingNotFound: 'Rectifying invoice generated and deleted by user before being emitted'
    }
  },
  result: {
    true: 'Correct',
    false: 'Rejected'
  },
  confirm: {
    acceptProFormPayer: {
      title: 'Accept pro formas as a supplier',
      selection: ' You have not selected pro formas. | You have selected {0} pro forma for a total of {1} to process in the selected dossier. | You have selected {0} pro formas for a total of {1} to be processed in the selected dossier.',
      continue: 'Do you wish to accept the selected pro formas?'
    },
    financeables: {
      title: 'Financeables summary',
      selection: ' You have not selected invoices. | You have selected {0} invoices with a total of {1} to process in the selected agreement: | You have selected {0} invoices with a total of {1} to process in the selected agreement:',
      selectionBankia: ' You have not selected invoices. | You have selected {0} invoices for a total of {1} to be processed in the selected file: You have selected {0} invoices for a total of {1} to be processed in the selected file:',
      continue: 'Do you want to continue with the financing request?',
      errorDiscount: `Can't request discounts if financing has already been requested in any selected invoice`,
      errorFactoring: `Can't request financing if discounts has already been requested in any selected invoice`,
      info: `Access log in is done through pop-up or pop-up window. if can't log in correctly, remember to check in these items aren't blocked in browser.`,
      doubt: 'For any questions about your request, please contact your financial'
    },
    acceptBilling: {
      title: 'List of invoices selected for acceptance',
      selection: ' You have not selected invoices. | You have selected {0} invoices with a total of {1} to accept. | You have selected {0} invoices with a total of {1} to accept.',
      continue: 'Do you want to accept the selected invoices?'
    },
    rejectProFormPayer: {
      title: 'List of projects selected for rejection',
      selection: ' You have not selected pro formas. | You have selected {0} pro forma for a total of {1} to reject. | You have selected {0} pro formas for a total de {1} to reject.',
      continue: 'Do you wish to reject the selected pro formas?',
      text: 'Please indicate the reason for rejection'
    },
    rejectBilling: {
      title: 'List of invoices selected to reject',
      selection: ' You have not selected invoices. | You have selected {0} invoices with a total of {1} to reject. | You have selected {0} invoices with a total of {1} to reject.',
      continue: 'Do you want to reject the selected invoices?',
      text: 'Please, enter the reason for the rejection'
    },
    unrejectBilling: {
      title: 'List of invoices selected to unreject',
      selection: ' You have not selected invoices. | You have selected {0} invoices with a total of {1} to unreject. | You have selected {0} invoices with a total of {1} to unreject.',
      continue: 'Do you want to unreject the selected invoices?',
      text: 'Please, enter the reason for the unrejection'
    },
    acceptSelfBilling: {
      title: 'List of invoices selected to accept',
      selection: ' You have not selected invoices. | You have selected {0} invoices with a total of {1} to accept | You have selected {0} invoices with a total of {1} to accept.',
      continue: 'Do you want to accept the selected invoices?'
    },
    rejectSelfBilling: {
      title: 'List of invoices to reject',
      selection: ' You have not selected invoices. | You have selected {0} invoices with a total of {1} to reject. | You have selected {0} invoices with a total of {1} to reject.',
      continue: 'Do you want to reject the selected invoices?',
      text: 'Please, enter the reason for the rejection'
    },
    cancelInvoice: {
      title: 'List of invoices to request its cancellation',
      selection: ' You have not selected invoices. | You have selected {0} invoices with a total of {1} to reject. | You have selected {0} invoices with a total of {1} to request its cancellation.',
      continue: 'Do you want to request the cancellation of the selected invoices?',
      text: 'Please enter the reason for the cancellation'
    },
    acceptCancel: {
      title: 'List of invoices to accept its cancellation',
      selection: ' You have not selected invoices. | You have selected {0} invoices with a total of {1} to reject. | You have selected {0} invoices with a total of {1} to accept its cancellation.',
      continue: 'Do you want to accept the cancellation of the selected invoices?',
      text: 'Please enter the reason for the acceptation',
      error: 'In order to cancel an invoice, previously the provider must request its cancellation.'
    },
    rejectCancel: {
      title: 'List of invoices to reject its cancellation',
      selection: ' You have not selected invoices. | You have selected {0} invoices with a total of {1} to reject. | You have selected {0} invoices with a total of {1} to reject its cancellation.',
      continue: 'Do you want to reject the cancellation of the selected invoices?',
      text: 'Please enter the reason for the rejection',
      error: 'In order to reject the cancellation of an invoice, previously the provider must request its cancellation'
    },
    issue: {
      title: 'List of invoices selected to be issued',
      selection: ' You have not selected invoices. | You have selected {0} invoices with a total of {1} to issue. | You have selected {0} invoices with a total of {1} to issue.',
      info: '',
      continue: 'Do you want to issue the selected invoices?'
    },
    issueProFromPayer: {
      title: 'List of pro formas selected to issue',
      selection: ' You have not selected pro formas. | You have selected {0} pro forma for a total de {1} to issue. | You have selected {0} pro formas with a total of {1} to issue.',
      continue: 'Do you want to issue the selected pro formas?'
    },
    issueSelf: {
      title: 'List of autoinvoices selected for issuing',
      selection: ' You have not selected autoinvoices. | You have selected {0} autoinvoices with a total of {1} to issue. | You have selected {0} autoinvoices with a total of {1} to issue.',
      continue: 'Do you want to issue the selected autoinvoices?'
    },
    issueproforma: {
      title: 'List of invoices selected to send pro formas',
      selection: ' You have not selected invoices. | You have selected {0} invoices with a total of {1} to send pro forma. | You have selected {0} invoices with a total of {1} to send pro formas.',
      continue: 'Do you want to send pro formas of the selected invoices?'
    },
    issueproformaSelf: {
      title: 'List of self-invoices selected to send pro formas',
      selection: ' No ha seleccionado autofacturas. | You have selected {0} autoinvoices with a total of {1} para enviar pro forma. | You have selected {0} autofacturas por un total de {1} para enviar pro formas.',
      continue: 'Do you want to send pro formas of the selected self invoices?'
    },
    send: {
      title: 'List of selected invoices to send',
      selection: ' You have not selected invoices. | You have selected {0} invoices with a total of {1} to send. | You have selected {0} invoices with a total of  {1} to send.',
      info: {
        contractReference: `The third-party invoice {1} does not include the "Contract Reference" (e.g.: T123456) which is generally obligatory for Bankia. In manually entered invoices this data must be collected in the section "Manager data". | Third party invoices {1} do not include the "Contract Reference" (e.g. T123456) which is generally obligatory for Bankia. In invoices entered manually, this information must be included in the "Manager's details" section.`,
        fixField: 'If you wish, you can still cancel the issuing/sending process in order to enter this information on the invoice.'
      },
      continue: 'Do you want to send selected invoices?'
    },
    remove: {
      title: 'List of selected invoices to remove',
      selection: ' You have not selected invoices. | You have selected {0} invoices with a total of {1} to remove. | You have selected {0} invoices with a total of {1} to remove.',
      continue: 'Do you want to remove the selected invoices?'
    },
    deleteProFormProvider: {
      title: 'List of pro formas selected for deletion',
      selection: ' You have not selected pro formas. | You have selected {0} pro forma for a total of {1} to delete. | You have selected {0} pro formas for a total of {1} to delete.',
      continue: 'Do you want to delete selected pro formas?'
    },
    removeSelf: {
      title: 'List of self invoices selected for deletion',
      selection: ' You have not selected autoinvoices. | You have selected {0} autoinvoices with a total of {1} to delete. | You have selected {0} self invoices with a total of {1} to delete.',
      continue: 'Do you want to delete selected self invoices?'
    }
  },
  headers: {
    created: 'Created',
    issue: 'Issued',
    id: 'Series - Number',
    provider: 'Provider',
    client: 'Client',
    status: 'Status',
    type: 'Type',
    serie: 'Serie',
    number: 'Number',
    amount: 'Amount',
    result: 'Result',
    comments: 'Comments',
    invoiceId: 'Invoice Id',
    format: 'Format'
  },
  csv: {
    invoiceId: 'Invoice Id',
    createDate: 'Created',
    incomeDate: 'Accrual date',
    issueDate: 'Issue date',
    provider: {
      name: 'Provider name',
      document: 'Provider VAT'
    },
    agent: {
      name: 'Agent name',
      document: 'Agent VAT'
    },
    client: {
      name: 'Client name',
      document: 'Client VAT'
    },
    status: 'Status',
    type: 'Type',
    taxableAmount: 'Taxable Amount',
    taxes: 'Taxes',
    amount: 'Amount'
  },
  filter: {
    byCreated: 'Created',
    byIssued: 'Issue date',
    from: 'From',
    to: 'To',
    byId: 'Serie and number',
    bySerie: 'Serie',
    byNumber: 'Number',
    byStatus: 'Status',
    byDocument: 'Document',
    byProviderDocument: 'Provider VAT',
    byClientDocument: 'Client VAT',
    byAmount: 'Amount (€)',
    delegations: 'Delegations',
    days: 'Days',
    months: 'Months',
    years: 'Years',
    other: 'Other'
  },
  download: {
    asCSV: 'Download CSV',
    asPDF: 'Download PDF'
  },
  helps: {
    type: 'The type of invoice(A) credit note and (R) rectificativa.'
  },
  actions: {
    acceptSelfBilling: 'Accept selfinvoices',
    rejectSelfBilling: 'Reject selfinvoices',
    acceptBilling: 'Accept invoices',
    rejectBilling: 'Reject invoices',
    unrejectBilling: 'Unreject invoices',
    financing: 'Request financing',
    acceptFinancing: 'Accept conditions',
    cancelInvoice: 'Cancel invoices',
    acceptCancellation: 'Accept cancellation',
    rejectCancellation: 'Reject cancellation'
  },
  types: {
    1: 'Invoice',
    4: 'Selfinvoice'
  },
  subtypes: {
    payment: ' (A)',
    rectify: ' (R)'
  },
  financing: {
    nif: 'N.I.F.',
    phone: 'Contact phone',
    email: 'Contact email',
    surname: 'Last name',
    iban: 'IBAN',
    error: 'Operation did not run correctly, please try again.',
    popup: 'Please, if you want to continue with the operation you must deactivate the blocking of pop-up windows.',
    errorMessages: {
      notExpedients: 'To request the advance of invoices you must have contracted the financing service',
      notGeneralModule: 'In order to request the advance of invoices through financing, you must have contracted the general module of the Internet Business Office with files in free format.',
      notExpedientsNorGeneralModule: 'In order to request the advance of invoices you must have contracted the general module of the Internet Office of Companies with sending of files in free format and the financing service.'
    },
    popFinanceables: {
      wait: 'Wait a moment, please.',
      access: 'he funding service is being accessed ...'
    },
    signValidation: 'Enter your signature key to continue with the operation.',
    simulation: {
      simulate: 'Simulate Financing',
      loading: 'The financing results are being calculated. Please wait...',
      result: 'Financing Results:',
      final: 'Final Liquidation:',
      retention: 'Amount Retention:',
      fee: 'Fees:',
      question: 'Would you like to see a simulation of the financing?'
    },
    tooltip: {
      nif: 'Administrator or company representative <br> Self employed: NIF',
      phone: 'Required to send the contract via SMS',
      iban: 'IBAN account that will be shown on the contract'
    }
  },
  issue: {
    errors: {
      tryAgain: 'Your invoice has been saved successfully, but a problem occurred during issuance. Try to issue it again from the list or edit it again.',
      maxInvoicesIssued: `It's not allowed sending more than {0} invoices with a free account | Only can issue {0} invoices more with a free account`,
      freeAccount: 'Free Account',
      maxInvoicesIssuedModal: 'You have reached your monthly limit of {0} bills / month go to the PRO account and enjoy all the advantages offered by the efactura service.'
    }
  },
  save: {
    errors: {
      maxAmount: 'The total amount of the invoice exceeds the maximum amount allowed (99,999,999.00 EUR).',
      maxSize: 'The limit (8192 Kbytes) for invoice attachments has been exceeded.'
    }
  },
  validations: {
    drafts: {
      noContractReference: `The invoice does not include the 'Contract Reference' (e.g. T123456) which is generally mandatory for Bankia. In invoices entered manually, this data must be collected in the section "Provider Data" (General Data). If you wish, you can still cancel the issuing / sending process to enter this delivery on the invoice.`
    },
    autodrafts: {
      noContractReference: `The self-invoice does not include the 'Contract Reference' (e.g. T123456) which is generally mandatory for Bankia. In invoices entered manually, this data must be collected in the section "Provider Data" (General Data). If you wish, you can still cancel the issuing / sending process to enter this delivery on the invoice.`
    },
    thirdPartyDrafts: {
      noContractReference: `The third party invoice does not include the 'Contract Reference' (e.g. T123456) which is generally mandatory for Bankia. In invoices entered manually, this data must be collected in the section "Manager Data" (General Data). If you wish, you can still cancel the issuing / sending process to enter this delivery on the invoice.`
    }
  }
}
